import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

import {
  throwError as observableThrowError,
  Observable,
  of as observableOf,
} from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IStats } from '../interfaces/stats';

@Injectable({
  providedIn: 'root',
})
export class StoreService {
  constructor(private _apiService: ApiService) {}

  getStoreSubsidiariesList(start_date, end_date): Observable<any> {
    //Filtrar datas para formato esperado em back-end
    //=============================================================
    start_date = new Date(start_date).toISOString().split('T')[0];
    end_date = new Date(end_date).toISOString().split('T')[0];
    return this._apiService
      .doGET(
        'store/statistics?start_date=' + start_date + '&end_date=' + end_date
      )
      .pipe(
        catchError((err) => {
          return observableOf([]);
        })
      );
  }

  stats(): Observable<IStats> {
    return this._apiService.doGET('store/stats').pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  storeMethodPayments(data): Observable<any> {
    return this._apiService.doPOST('store/method-payments', data).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  getMethodPayments(): Observable<any> {
    return this._apiService.doGET('store/method-payments').pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  storeDelivery(data): Observable<any> {
    return this._apiService.doPOST('store/delivery', data).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  getDelivery(): Observable<any> {
    return this._apiService.doGET('store/delivery').pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  getDriveThru(): Observable<any> {
    return this._apiService.doGET('store/drivethru').pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  storeDriveThru(data): Observable<any> {
    return this._apiService.doPOST('store/drivethru', data).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  logo(): Observable<any> {
    return this._apiService.doGET('store/logo').pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  canDelivery(idestabelecimento, idendereco): Observable<any> {
    return this._apiService
      .doGET('store/' + idestabelecimento + '/make/delivery/' + idendereco)
      .pipe(
        catchError((err) => {
          return observableOf([]);
        })
      );
  }

  subscription(data): Observable<any> {
    return this._apiService.doPOST('subscription', data).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }
}
